// Central list of head-bundled files.
// Edit this file to add/remove items from the shared head bundle.
// Use ordered imports: earlier lines execute first.
// Keep this list minimal and fast.

// Auth client should be available before GTM bootstrap and app scripts
import '../../utils/logger.js';
import '../../js/storage-management.js';
import '../../auth/auth.js';
import '../../js/globalState.js';
import '../../js/preloader-manager.js';

import '../../js/aframe-troika-text.js';

// Add more local side-effect scripts here, e.g. tiny polyfills or flags:
// import '../shared/polyfills/focus-visible.js';

// If you ever need a truly tiny inline snippet that must run before everything else,
// prefer adding it directly in the HTML template as a short inline <script>.
